
module.exports = angular.module('msi.paymetric', [
  require('@ordergroove/brandy/src/app/utils'),
  require('./paymetric.service')
]).name;

angular.module(module.exports)
  .component('ogPaymetric', require('./paymetric'));
